export default "/Frontend/dist/event-background4.0407e82e67683bd9731ade02f9affe43.svg";